import { ModalFooter } from '@auviknetworks/iceberg-ui';
import { SIDEBAR_WIDTH } from 'application/Shared/Constants';
import React from 'react';

export const FixedPositionPageFooter = ({
    children
}: {
    children: React.ReactNode;
}) => (
    <ModalFooter
        sx={{
            bottom: 0,
            display: 'flex',
            justifyContent: 'flex-end',
            left: SIDEBAR_WIDTH,
            padding: '16px',
            position: 'fixed',
            right: 0,
            zIndex: 1
        }}
    >
        {children}
    </ModalFooter>
);
